import { ThemeProvider, calculatePalette } from '@bizzabo/design-system';
import { useRingThemeCustomization } from '@bizzabo/entities';
import { ThemeProviderCustomizationProps } from './ThemeProviderCustomizationProps';

const AppToolsThemeProviderCustomization: React.FC<ThemeProviderCustomizationProps> = ({
    eventUniqueName,
    children,
}) => {
    const theme = {};
    const rawCustomization = useRingThemeCustomization(eventUniqueName);
    const customPalette = calculatePalette({
        backgroundColor: 'white',
        surfaceColor: rawCustomization?.secondaryColor ?? '#FFFFFF',
        interactiveColor: rawCustomization?.toolbarButtonsColor ?? '#404040',
    });

    return (
        <ThemeProvider customization={customPalette} customTheme={theme}>
            {children}
        </ThemeProvider>
    );
};

export default AppToolsThemeProviderCustomization;
